import { format, isValid, parse } from 'date-fns';
import { DEFAULT_CUSTOMER_LOCALE, type CustomerLocale } from '@/document-render/domain/CustomerLocale';
import { dateFormatToDateFnsPattern } from '@/document-render/domain/customerLocaleFormatters';

const ISO_DATE_PREFIX = /^\d{4}-\d{2}-\d{2}/;
const SLASH_DATE = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;

/**
 * Formats cover-page dates for display using the customer locale pattern
 * (US `MM/dd/yyyy` by default). ISO (`yyyy-MM-dd` / date-time) and slash
 * month/day values are normalized; other branding override strings are returned unchanged.
 */
export function formatCoverDisplayDate(raw: string, locale: CustomerLocale = DEFAULT_CUSTOMER_LOCALE): string {
  const trimmed = raw.trim();
  if (!trimmed) return '';

  const pattern = dateFormatToDateFnsPattern(locale.dateFormat);

  if (ISO_DATE_PREFIX.test(trimmed)) {
    const date = parse(trimmed.slice(0, 10), 'yyyy-MM-dd', new Date());
    if (isValid(date)) return format(date, pattern);
  }

  const slashMatch = SLASH_DATE.exec(trimmed);
  if (slashMatch) {
    // Prefer American M/d when locale is US; try d/M first for UK so day>12 values parse.
    const parseOrders = locale.dateFormat === 'UkDayMonthYear' ? (['d/M/yyyy', 'M/d/yyyy'] as const) : (['M/d/yyyy', 'd/M/yyyy'] as const);

    for (const parsePattern of parseOrders) {
      const date = parse(trimmed, parsePattern, new Date());
      if (isValid(date)) return format(date, pattern);
    }
  }

  return trimmed;
}
